export interface INPSState {
  keycloakToken?: string;
}

export const defaultState: INPSState = {
  keycloakToken: "",
};
